import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class VisionContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
            
             <div class="section-full p-t80 p-b50 bg-gray">
                <div class="container">
                
                    
                    <div class="m-b50">
                        <div class="section-head">
                            <h2 class="text-uppercase">VISION, MISSION AND QUALITY</h2>
                            <div class="wt-separator-outer">
                                    <div class="wt-separator style-square">
                                        <span class="separator-left site-bg-primary"></span>
                                        <span class="separator-right site-bg-primary"></span>
                                    </div>
                                </div>
                        </div>
                        <div class="section-content m-b50">
                            <div class="row">
                            
                                
                                
                                <div class="col-lg-6 col-md-6 m-b30">
                                    <div class="wt-icon-box-wraper bx-style-1 p-a30 center bg-white">
                                        <img src={this.props.content[6].image}  alt=""/>
                                        <div class="icon-content">
                                            <h2 class="wt-tilte text-uppercase">{this.props.content[6].subtitle}</h2>
                                            <div  dangerouslySetInnerHTML={{ __html: this.props.content[6].description}} />  
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-lg-6 col-md-6 m-b30">
                                    <div class="wt-icon-box-wraper bx-style-1 p-a30 center bg-white">
                                        
                                        	<img src={this.props.content[7].image}  alt=""/>
                                        
                                        <div class="icon-content">
                                            <h2 class="wt-tilte text-uppercase">{this.props.content[7].subtitle}</h2>
                                            <div  dangerouslySetInnerHTML={{ __html: this.props.content[7].description}} />  
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-lg-12 col-md-6 m-b30">
                                    <div class="wt-icon-box-wraper bx-style-1 p-a30 center bg-white">
                                        <img src={this.props.content[9].image} alt=""/>
                                        <div class="icon-content">
                                            <h2 class="wt-tilte text-uppercase">{this.props.content[9].subtitle}</h2>
                                            <div  dangerouslySetInnerHTML={{ __html: this.props.content[9].description}} />  
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
				</div>
			</div>
  
        </div>
       

    );
 
    }
}

export default VisionContent;